import React, { Component, useState, useEffect } from "react";
import { withTranslation, Trans, useTranslation } from "react-i18next";
import classes from "../../App.module.css";
import axios from "axios";
import _ from 'lodash';

import "../../assets/css/customstyles.css";
import "../../assets/css/theme_grey.css";
import "../../assets/css/theme_blue.css";
import "../../assets/css/theme_green.css";
import "../../assets/css/theme_red.css";

import "../../assets/css/customstyles.css";
import "../../assets/css/theme_grey.css";
import "../../assets/css/theme_blue.css";
import "../../assets/css/theme_green.css";
import "../../assets/css/theme_red.css";

import { Link, Redirect, useHistory } from "react-router-dom";
// import { Link, useHistory } from "react-router-dom";
import { MenuItem, Menu, Tab, TabBar, Button } from "@dhis2/ui";

import {
  Apps,
  Settings,
  Account,
  Exit,
  Message,
  AttachFile,
  Email,
  FolderOpen,
} from "@dhis2/ui-icons";
import OfflineDb from "../../db";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faHome,
  faUserPlus,
  faSearch,
  faBullhorn,
  faFileAlt,
  faUsers,
  faFileInvoice,
  faEdit,
  faWifi,
  faCog,
  faSignOutAlt,
  faFileSignature,
  faUserFriends,
  faShareSquare,
  faPrescriptionBottle,
  faFlask,
  faPills,
  faMale,
  faRobot,
  faVideo,
  faEye,
  faFilePdf,
  faFilter,
  faBell,
  faHdd,
  faBullseye
} from "@fortawesome/free-solid-svg-icons";

import Grid from "@material-ui/core/Grid";
import { Configuration } from "../../assets/data/config";
import { apiServices } from "../../services/apiServices";
import Customcircularprogress from "./Customcircularprogress.js";
import Customcircularprogress1 from "./Customcircularprogress1.js";
import Customcircularprogress2 from "./Customcircularprogress2.js";
import {
  setSidebarToggel,
  getPageRelaodFlag,
} from "../../redux/actions/action";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import Disclaimer from "../../component/disclaimer/Disclaimer";
import imgUrl from "../../assets/images/imageUrl.js";
//import swal from 'sweetalert';
import swal from "@sweetalert/with-react";
const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
  },
}))(LinearProgress);

function NewThemeHomePage() {
  const [ConfigurationFromServer,setConfigurationFromServer] = useState(null);
  const metaDataParam = Configuration.homepage.metaDataParam;
  const relationshipTypeParams = Configuration.homepage.relationshipTypeParam;
  const DEGParams = Configuration.homepage.DEGParams;
  const OUGroupParams = Configuration.homepage.OUGroupParam;
  const programRuleVariableParam =
    Configuration.homepage.programRuleVariableParam;
  const dataSetParams = Configuration.homepage.dataSets;
  const OUStructureParams = Configuration.homepage.OUStrutureParams;
  const [reloadData, setReloadDataFlag] = React.useState(false);
  const [progress, setProgress] = React.useState(0);
  const [sessionUserBoValue, setSessionUserBoValue] = React.useState(null);
  const [userConsent, setUserConsent] = React.useState(null);
  const [userConsentAttributeIndex, setUserConsentAttributeIndex] =
    React.useState(null);
  const [programData, setProgramData] = React.useState(null);
  const { t, i18n } = useTranslation();
  const [switchBoxFlag, setSwitchBoxFlag] = React.useState(false);
  const progressIncrement = progress + 10;

  async function getUserBo() {
    let loginDetails = await OfflineDb.getDataFromPouchDB("loginDetails");
    setSessionUserBoValue(loginDetails.data);
    
    let configurations = await OfflineDb.getDataFromPouchDB('configurations')
    setConfigurationFromServer(configurations.data.configuration)
  }

  function appUpdate(){
    swal({
      title: t("Application update"),
      text: t("The current version of the application is no longer supported. Kindly upgrade the same!"),
      icon: "warning",
      button: t("Update")
    }).then(res=>{
      if(window.cordova && window.cordova.platformId == 'ios'){
          window.open(Configuration.mobileAppiOSUrl, '_system');
      }else{
          window.open(Configuration.mobileAppDownloadUrl, '_system');
      }
    })
  }

  // Version comparison function
  function compareVersions(v1, v2) {
    const v1Parts = v1.split('.').map(Number);
    const v2Parts = v2.split('.').map(Number);
    for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
        const part1 = v1Parts[i] || 0; // Default to 0 if segment is missing
        const part2 = v2Parts[i] || 0;
        if (part1 < part2) return -1; // v1 is less than v2
        if (part1 > part2) return 1;  // v1 is greater than v2
    }
    return 0; // v1 is equal to v2
  }

  useEffect(() => {
    getUserBo();
    i18n.changeLanguage(localStorage.getItem("locale"));
    document.addEventListener('resume', () => {
      try{
          OfflineDb.getDataFromPouchDB('metaData')
              .then(metaData => {
              OfflineDb.getDataFromPouchDB('loginDetails')
              .then(loginDetails => {
                  if (loginDetails.data != undefined) {
                      const versionCheckParam = 'metadata?fields=:owner,displayName&programs:filter=id:eq:' + loginDetails.data.programs[0] + '&programs:fields=:owner,unique,playName,attributeValues[:all,attribute[id,name,displayName]]'
                      apiServices.getAPI(versionCheckParam)
                          .then(versionCheck => {
                              console.log('versionCheck', versionCheck)
                              if (metaData.data != undefined && versionCheck.data != undefined && Array.isArray(versionCheck.data.programs)) {
                                  if(window.cordova){
                                      let result = _.filter(versionCheck.data.programs[0].attributeValues, ['attribute.name', 'AppVersion'])
                                      // if(result.length > 0 && result[0].value != Configuration.mobileAppVersion){
                                        if(result.length > 0 && compareVersions(Configuration.mobileAppVersion, result[0].value) < 0){
                                        appUpdate()
                                      }
                                  }
                              }
                          })
                  }
              })
          })
      }catch(e){

      }
    })
  }, []);

  useEffect(() => {
    if (progress == 100) {
      setReloadDataFlag(false);
    }
  }, [progress]);

  useEffect(() => {
    if (sessionUserBoValue != null) {
      checkUserConsent();
      try{
        if(navigator.onLine && sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && (sessionUserBoValue.userRoles[0].name =='HTC' || sessionUserBoValue.userRoles[0].name =='ART user' || sessionUserBoValue.userRoles[0].name =='ART-I user')){
          let artEnrollmentFacilities = []
          apiServices.postAPI('save/org/list', {"uid" : "diBTNzaEMGg"})
          .then(ouResponse => {
              const fetchOUOptions = ouResponse.data.data
              const OUOptions = fetchOUOptions;
              if(OUOptions.length > 0) {
                  OUOptions.map(items => {
                      let obj = {
                          'id': items.uid , 
                          'label': items.name, 
                          'value': items.name//items.uid
                      }
                      artEnrollmentFacilities.push(obj)
                  })
                  artEnrollmentFacilities = _.orderBy(artEnrollmentFacilities, ['label'],['asc'])
                  localStorage.setItem("artEnrollmentFacilities",JSON.stringify(artEnrollmentFacilities));
              }
          })
        }
        apiServices.getAPI('organisationUnits?&filter=attributeValues.attribute.id:eq:XbWlXexPdTb&filter=attributeValues.value:eq:true&paging=false')
        // filter:attribute=XbWlXexPdTb:EQ:true&paging=false
          // filte:attributeValues:ilike:id=XbWlXexPdTb&paging=false')
        .then(OUAPI=>{
          console.log("OUAPI",OUAPI.data.organisationUnits)
        localStorage.setItem("OUAPI",JSON.stringify(OUAPI.data.organisationUnits));
        }) 
        // console.log("OUAPI",OUAPI)
      }catch(e){

      }
    }
  }, [sessionUserBoValue]);

  useEffect(() => {
    OfflineDb.removeDataFromPouchDB("activeCaseDetails");
    OfflineDb.removeDataFromPouchDB("activeCaseFormData");
    OfflineDb.removeDataFromPouchDB("linkContactFlag");
    OfflineDb.setDataIntoPouchDB("transferFlag", { type: null });
    if(localStorage.getItem('referral-type')){
        localStorage.removeItem('referral-type')
    }
    if (reloadData == true) {
      OfflineDb.getDataFromPouchDB("loginDetails").then((loginDetails) => {
        if (loginDetails.data != undefined) {
          //First Call
          apiServices
            .getAPI(
              "programs.json?fields=[id,displayFormName,publicAccess,organisationUnit[id,path,displayName]]&paging=false&filter=id:in:[" +
                loginDetails.data.programs.toString() +
                "]"
            )
            .then((programsDetails) => {
              const filterProgramWithAccess =
                programsDetails.data.programs.filter(
                  (obj) => obj.publicAccess == "rwrw----"
                );

              //Second call
              apiServices.getAPI(metaDataParam).then((metaData) => {
                metaData.data.programs.map((programs) => {
                  const filterOU = programs.organisationUnits.find(
                    (array) =>
                      array.id == loginDetails.data["organisationUnits"][0].id
                  );

                  if (filterOU != undefined) {
                    metaData.data.programs = [programs];
                    loginDetails.data.programs = [metaData.data.programs[0].id];

                    OfflineDb.setDataIntoPouchDB(
                      "loginDetails",
                      loginDetails.data
                    );
                    setProgress(10);
                    OfflineDb.setDataIntoPouchDB("metaData", metaData.data);
                    setProgress(20);
                    //need for consent
                    //setProgramData(metaData.data)
                    metaData.data.programs[0].programTrackedEntityAttributes.map(
                      (TEAField) => {
                        if (
                          TEAField.trackedEntityAttribute.unique &&
                          TEAField.trackedEntityAttribute.displayName.toLocaleLowerCase() ==
                            "uic"
                        ) {
                          //setUICFieldId(TEAField.trackedEntityAttribute.id)
                          let generateOfflineUICUrl = `33/trackedEntityAttributes/${TEAField.trackedEntityAttribute.id}/generateAndReserve?numberToReserve=100`;
                          apiServices
                            .getAPI(generateOfflineUICUrl)
                            .then((response) => {
                              OfflineDb.setDataIntoPouchDB(
                                "offlineUICList",
                                response.data
                              );
                            });
                        }
                      }
                    );
                  } else {
                    OfflineDb.setDataIntoPouchDB("metaData", metaData.data);
                    setProgress(20);
                  }
                });

                //Third call
                apiServices.getAPI(relationshipTypeParams).then((response) => {
                  const relationshipTypes = response.data.relationshipTypes;
                  if (relationshipTypes.length > 0) {
                    relationshipTypes.map((relationshipType) => {
                      if (
                        relationshipType.fromConstraint.program.id ==
                        loginDetails.data.programs[0]
                      ) {
                        OfflineDb.setDataIntoPouchDB(
                          "relationshipTypeId",
                          relationshipType.id
                        );
                        setProgress(30);
                      } /*else {
                                                        OfflineDb.setDataIntoPouchDB('relationshipTypeId', "")
                                                        setProgress(30)
                                                    }*/
                    });
                  } /*else {
                                                OfflineDb.setDataIntoPouchDB('relationshipTypeId', "")
                                                setProgress(30)
                                            }*/

                  //Fourth Call
                  apiServices.getAPI(DEGParams).then((dataElementGroup) => {                    
                    //sort dataElementGroup                    
                    dataElementGroup.data.dataElementGroups.map(dataElementGroups => {
                      metaData.data.programs[0].programStages.map(programStages => {
                        let findDataElementInStage = programStages.programStageDataElements.find(x => x.dataElement.displayName == dataElementGroups.displayName)
                        if(findDataElementInStage) {
                          dataElementGroups.dataElements.map(dataElements => {
                            let findDataElementOptionsInStage = programStages.programStageDataElements.find(x => x.dataElement.id == dataElements.id)
                            if(findDataElementOptionsInStage) {
                              dataElements['sortOrder'] = findDataElementOptionsInStage.sortOrder
                            }
                          })
                        }
                        
                      })
                      dataElementGroups.dataElements = _.orderBy(dataElementGroups.dataElements, ['sortOrder'], ['asc'])
                    })
                    OfflineDb.setDataIntoPouchDB(
                      "dataElementGroup", dataElementGroup.data
                    );
                    setProgress(40);

                    //Fifth Call
                    apiServices.getAPI(OUGroupParams).then((OUGroups) => {
                      OfflineDb.setDataIntoPouchDB(
                        "organisationUnitGroups",
                        OUGroups.data
                      );
                      setProgress(50);
                      const programRuleParam =
                        "programRules?filter=program.id:eq:" +
                        loginDetails.data.programs[0] +
                        "&filter=name:ne:default&fields=id,displayName,condition,description,program[id],programStage[id],priority,programRuleActions[id,content,location,data,programRuleActionType,programStageSection[id],dataElement[id],trackedEntityAttribute[id],option[id],optionGroup[id],programIndicator[id],programStage[id]]&paging=false";

                      apiServices
                        .getAPI(programRuleParam)
                        .then((programRule) => {
                          OfflineDb.setDataIntoPouchDB(
                            "programRules",
                            programRule.data
                          );
                          setProgress(60);

                          apiServices
                            .getAPI(programRuleVariableParam)
                            .then((programRuleVariable) => {
                              OfflineDb.setDataIntoPouchDB(
                                "programRulesVariables",
                                programRuleVariable.data
                              );
                              setProgress(70);
                              apiServices
                                .getAPI(dataSetParams)
                                .then((dataSet) => {
                                  OfflineDb.setDataIntoPouchDB(
                                    "dataEntrySet",
                                    dataSet.data
                                  );
                                  setProgress(80);
                                  apiServices.postAPI('bulk/orgnisation/getstate', {})
                                  .then(ouStateResponse => {
                                    OfflineDb.setDataIntoPouchDB(
                                      "allStates",
                                      ouStateResponse.data
                                    );
                                    apiServices.postAPI('indicators/gettownshipdata', {})
                                    .then(ouTownshipResponse => {
                                      OfflineDb.setDataIntoPouchDB(
                                        "allTownships",
                                        ouTownshipResponse.data
                                      );
                                      setProgress(90);
                                    

                                  //apiServices.getexternalAPI('https://cdn.jsdelivr.net/gh/AquaSwami/shared/region.json')
                                  // axios({
                                  //     method: 'GET',
                                  //     url: 'https://cdn.jsdelivr.net/gh/AquaSwami/shared/region.json',
                                  //     headers: {
                                  //         //'Cache-Control': 'no-cache',
                                  //         //Authorization: basicAuth != null ? basicAuth : 'Basic RGF0YUNhcHR1cmVVbml0QHByb2R1Y3Qub3JnOkRhdGFDYXB0dXJlVW5pdEAxMjM=',    //'Basic SGVhbHRod29ya2VyQGx0Ymkub3JnOkhlYWx0aHdvcmtlckAxMjM=' //'Basic RGF0YUVudHJ5QHNhdmUuY29tOkRhdGFFbnRyeUAxMjM='
                                  //         // 'Content-Security-Policy': 'self',
                                  //         // 'X-Content-Type-Options': 'nosniff',
                                  //         // 'X-XSS-Protection': "1; mode=block",
                                  //         "Access-Control-Allow-Origin": "*",
                                  //         // "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
                                  //         // "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, Authorization",
                                  //         "Content-Type" : "application/json",
                                  //         'crossdomain': true
                                  //     }
                                  // })

                                  axios
                                    .get(
                                      "https://cdn.jsdelivr.net/gh/duretech/shared@master/OUStructureEOSave.json",
                                      function (req, res) {
                                        res.header(
                                          "Access-Control-Allow-Origin",
                                          "*"
                                        );
                                      }
                                    )
                                    .then((OUStructureParams) => {
                                      OfflineDb.setDataIntoPouchDB(
                                        "OUStructureJSON",
                                        OUStructureParams.data
                                      );
                                      setProgress(100);
                                      setReloadDataFlag(false);
                                    });
                                  })
                                  })
                                });
                            });
                        });
                    });
                  });
                });
              });
            });
        }
      });
    } else {
      if (reloadData == false) {
        OfflineDb.getDataFromPouchDB("dataElementGroup").then(
          (dataElementGroup) => {
            if (dataElementGroup.data == undefined) {
              if (!reloadData) {
                setReloadDataFlag(true);
              }
            }

            if (reloadData == false) {
              OfflineDb.getDataFromPouchDB("metaData").then((metaData) => {
                if (metaData.data == undefined) {
                  if (!reloadData) {
                    setReloadDataFlag(true);
                  }
                }
                //need for consent
                setProgramData(metaData.data);

                OfflineDb.getDataFromPouchDB("loginDetails").then(
                  (loginDetails) => {
                    if (loginDetails.data != undefined) {
                      const versionCheckParam =
                        "metadata?fields=:owner,displayName&programs:filter=id:eq:" +
                        loginDetails.data.programs[0] +
                        "&programs:fields=:owner,unique,playName,attributeValues[:all,attribute[id,name,displayName]]";
                      apiServices
                        .getAPI(versionCheckParam)
                        .then((versionCheck) => {
                          //debugger
                          if (
                            metaData.data != undefined &&
                            versionCheck.data != undefined &&
                            Array.isArray(versionCheck.data.programs)
                          ) {
                            if (
                              versionCheck.data.programs[0].version !=
                              metaData.data.programs[0].version
                            ) {
                              if (!reloadData) {
                                setReloadDataFlag(true);
                              }
                            }
                            // logic for mobile app
                            if(window.cordova){
                              let result = _.filter(versionCheck.data.programs[0].attributeValues, ['attribute.name', 'AppVersion'])
                              // if(result.length > 0 && result[0].value != Configuration.mobileAppVersion){
                                if(result.length > 0 && compareVersions(Configuration.mobileAppVersion, result[0].value) < 0){
                                appUpdate()
                              }
                            }
                          }
                        });
                    }
                  }
                );

                if (reloadData == false) {
                  OfflineDb.getDataFromPouchDB("organisationUnitGroups").then(
                    (organisationUnitGroups) => {
                      if (organisationUnitGroups.data == undefined) {
                        if (!reloadData) {
                          setReloadDataFlag(true);
                        }
                      }

                      if (reloadData == false) {
                        OfflineDb.getDataFromPouchDB("programRules").then(
                          (programRules) => {
                            if (programRules.data == undefined) {
                              if (!reloadData) {
                                setReloadDataFlag(true);
                              }
                            }
                            if (reloadData == false) {
                              OfflineDb.getDataFromPouchDB("allStates").then(
                                (allStates) => {
                                  if (allStates.data == undefined) {
                                    if (!reloadData) {
                                      setReloadDataFlag(true);
                                    }
                                }
                                if (reloadData == false) {
                                  OfflineDb.getDataFromPouchDB("allTownships").then(
                                    (allTownships) => {
                                      if (allTownships.data == undefined) {
                                        if (!reloadData) {
                                          setReloadDataFlag(true);
                                        }
                                    }
                                  if (reloadData == false) {
                                    OfflineDb.getDataFromPouchDB("dataEntrySet").then(
                                      (dataEntrySet) => {
                                        if (dataEntrySet.data == undefined) {
                                          if (!reloadData) {
                                            setReloadDataFlag(true);
                                          }
                                        }
                                      }
                                    );
                                  }
                                })
                                }
                              })
                            }
                          }
                        );
                      }
                    }
                  );
                }
              });
            }
          }
        );
      }
    }
  }, [reloadData]);

  function checkUserConsent() {
    if (
      sessionUserBoValue != null &&
      sessionUserBoValue.attributeValues &&
      sessionUserBoValue.attributeValues.length > 0
    ) {
      sessionUserBoValue.attributeValues.map((val, indx) => {
        if (val.attribute.displayName === "IsConsent" && val.value == "true") {
          setUserConsent(true);
          setUserConsentAttributeIndex(indx);
          //alert("consent submitted")
        } else {
          setUserConsent(false);
          setUserConsentAttributeIndex(indx);
        }
      });
    }
  }
  function setConset() {
    setUserConsent(true);
  }
  function getFlag(flag) {
    // setSwitchBoxFlag(!flag)
    return switchBoxFlag;
  }
  function setFlag(flag) {
    setSwitchBoxFlag(!flag);
  }
  function rendermenuitems() {
    ConfigurationFromServer.homepage.menuItems = _.filter(ConfigurationFromServer.homepage.menuItems,{"showMenu":true})
    let flag = true;
    if(sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && (sessionUserBoValue.userRoles[0].name =='HTC' || sessionUserBoValue.userRoles[0].name =='ART user'|| 
      sessionUserBoValue.userRoles[0].name == 'ART-I user'
    )){
      ConfigurationFromServer.homepage.menuItems = [];
      ConfigurationFromServer.homepage.menuItems.push({
        "name": "Search",
        "icon": faFilter,
        "path": "/layout/registration",
        "showMenu": true,
        "iconClass":"searchbg"
      },
      {
        "name": "Alert",
        "icon": faBell,
        "path": "/layout/alerts",
        "showMenu": true,
        "iconClass":"alertbg"
      },{
        "name": "Referral Cases",
        "icon": faShareSquare,
        "path": "/layout/referral",
        "showMenu": true,
        "iconClass":"referalbg"
      },
      {
        "name": "Offline Client",
        "icon": faHdd,
        "path": "/layout/offline-clients",
        "showMenu": true,
        "iconClass":"myclientsmenubg"
      })
    }else if(sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && sessionUserBoValue.userRoles[0].name =='Supervisor user'){
      ConfigurationFromServer.homepage.menuItems = [];
      ConfigurationFromServer.homepage.menuItems.push({
        "name": "Referral Cases",
        "icon": faShareSquare,
        "path": "/layout/referral",
        "showMenu": true,
        "iconClass":"referalbg"
      },
      {
        "name": "Dashboard",
        "icon": faHome,
        "path":  "/layout/dashboardChart",//"/layout/dashboardChart",
        "showMenu": true,
        "iconClass":"dashboardmenubg"
      },
      {
        "name": "Targets",
        "icon": faHome,
        "path": "/layout/targets",
        "showMenu": true,
        "iconClass":"targetmenubg"
      })
    }else{
      ConfigurationFromServer.homepage.menuItems = [];
      ConfigurationFromServer.homepage.menuItems.push({
        "name": "Search",
        "icon": faFilter,
        "path": "/layout/registration",
        "showMenu": true,
        "iconClass":"searchbg"
      },
      {
        "name": "Alert",
        "icon": faBell,
        "path": "/layout/alerts",
        "showMenu": true,
        "iconClass":"alertbg"
      },{
        "name": "My Clients",
        "icon": faUsers,
        "path": "/layout/cases",
        "showMenu": true,
        "iconClass":"myclientsmenubg"
      },
      {
        "name": "Dashboard",
        "icon": faHome,
        "path": "/layout/dashboardChart",
        "showMenu": true,
        "iconClass":"dashboardmenubg"
      })
    }
    if (ConfigurationFromServer.homepage.menuItems.length % 2 != 0) {
      ConfigurationFromServer.homepage.menuItems.push({
        name: "",
        icon: "",
        path: "",
        showMenu: true,
        iconClass: "",
      });
    }
    return ConfigurationFromServer.homepage.menuItems.map((menuItems, index) => {      
      if (index % 2 == 0) {
        flag = !flag;
      }
      flag = !flag;
      //if(menuItems.showMenu){
      /*if(sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && sessionUserBoValue.userRoles[0].name =='Supervisor user'){
          flag = true;
      }*/
      return (
        <Grid
          key={index}
          item
          xs={6}
          sm={6}
          md={6}
          className={menuItems.showMenu ? "" : "hide"}
        >
          
            <Link
              className={reloadData ? "anchorLink disbaledLink" : "anchorLink "}
              to={menuItems.path}
            >
            <div
            className={
              flag ? "homemenucontainer background-theme" : "homemenucontainer"
            }
          >
              <p className="zero text-center">
                <div
                  className={
                    flag
                      ? menuItems.iconClass + " background_white"
                      : menuItems.iconClass + " background-theme"
                  }
                ></div>
              </p>
              <p
                className={
                  flag ? "text-uppercase color-white" : "text-uppercase"
                }
              >
                {t(menuItems.name)}
              </p>
              </div>
            </Link>
          
        </Grid>
      );
              
    });
  }
  return (
    <div className={classes.container}>
      <main style={{ display: "flex", height: "100%", width: "100%" }}>
        <section
          className="mainsection pb-0 pT-55"
          style={{
            // backgroundColor: '#fff',
            flexGrow: 1,
            padding: 0,
          }}
        >
          <Grid container spacing={0} className="">
            <Grid item xs={12} sm={12} md={12} className="pos-relative">
              <div className="homeheaderdiv">
                <h3 className="text-uppercase zero hide1">{t("Homepage")}</h3>
                <div class="custom-shape-divider-top-1617788413">
                  <svg
                    data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1200 120"
                    preserveAspectRatio="none"
                  >
                    <path
                      d="M0,0V7.23C0,65.52,268.63,112.77,600,112.77S1200,65.52,1200,7.23V0Z"
                      class="shape-fill"
                    ></path>
                  </svg>
                </div>
              </div>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} className="menulistingholder">
            {reloadData && progress != 100 ? (
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  {/* <Grid container spacing={3}> */}

                  <p className="homepageappdesc">{t("Syncing data")}</p>
                  <BorderLinearProgress
                    variant="determinate"
                    value={progress}
                  />
                  <p className="homepageappdesc">
                    {" "}
                    {progress} % {t("completed")}{" "}
                  </p>
                  {/* </Grid> */}
                </Grid>
              </Grid>
            ) : !userConsent &&
              userConsent != null &&
              sessionUserBoValue != null &&
              sessionUserBoValue.attributeValues ? (
              <Grid item xs={12} sm={12} md={12} className="">
                <div className="choose_alertdiv">
                  <Disclaimer
                    disclaimerContents={
                      programData != null
                        ? programData.programs[0].description
                        : "N/A"
                    }
                    sessionUserBoValue={sessionUserBoValue}
                    userConsentAttributeIndex={userConsentAttributeIndex}
                    userConsent={setConset}
                  />
                </div>
              </Grid>
            ) : (
              <div className="homemenupageholder">
                <div className="w-100">
                  <Grid container spacing={0} className="">
                    {ConfigurationFromServer ? rendermenuitems(): <></>}
                  </Grid>
                </div>
              </div>
            )}
          </Grid>
        </section>
      </main>
    </div>
  );
}

export default NewThemeHomePage;
